<template>
<VueMultiselect
  ref="selectSearch"
  v-model="innerValue"
  :options="safeOptions"
  :searchable="true"
  :allow-empty="true"
  :close-on-select="true"
  :clear-on-select="false"
  :preserve-search="true"
  :placeholder="placeholderText"
  label="text"
  track-by="value"
  :preselect-first="false"
  @open="scrollToSelectedOption"
  @close="resetSearch"
  @select="closeDropdown"
  @remove="scrollToOption"
/>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
    components: {
        VueMultiselect
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        modelValue: {
            type: [String, Number, Boolean, null],
            default: null
        }
    },
    emits: ['update:modelValue'],
    computed: {
        safeOptions() {
            return Array.isArray(this.options) ? this.options : []
        },
        innerValue: {
            get() {
                return this.safeOptions.find(option => option.value === this.modelValue) || null
            },
            set(option) {
                this.$emit('update:modelValue', option ? option.value : null)
            }
        },
        placeholderText() {
            return this.innerValue ? this.innerValue.text : this.$t('pleaseSelect')
        }
    },
    methods: {
        closeDropdown() {
            setTimeout(() => {
                const select = this.$refs.selectSearch
                if (!select) {
                    return
                }

                select.deactivate()
                select.isOpen = false
            }, 0)
        },
        resetSearch() {
            this.$nextTick(() => {
                if (this.$refs.selectSearch) {
                    this.$refs.selectSearch.search = ''
                    this.scrollToSelectedOption()
                }
            })
        },
        scrollToSelectedOption() {
            this.scrollToOption(this.innerValue)
        },
        scrollToOption(option) {
            this.$nextTick(() => {
                const select = this.$refs.selectSearch
                if (!select || !option) {
                    return
                }

                const optionIndex = this.safeOptions.findIndex(item => item.value === option.value)
                const list = select.$refs ? select.$refs.list : null
                if (optionIndex < 0 || !list) {
                    return
                }

                const optionHeight = select.optionHeight || 40
                const visibleHeight = list.clientHeight || select.optimizedHeight || optionHeight
                const targetTop = Math.max((optionIndex * optionHeight) - ((visibleHeight - optionHeight) / 2), 0)

                select.pointer = optionIndex
                list.scrollTop = targetTop
            })
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
    .multiselect {
        min-width: 190px;
        min-height: 35px;
    }
    .multiselect__tags {
        min-height: 38px !important;
        padding: 7px 40px 0 8px !important;
        border: 1px solid #cfcfcf;
        box-shadow: none;
        color: rgba(0, 0, 0, 0.6);
    }
    .multiselect__placeholder {
        margin-bottom: 6px !important;
    }
</style>
